import { render } from "./meals.vue?vue&type=template&id=5623bf96"
import script from "./meals.vue?vue&type=script&lang=js"
export * from "./meals.vue?vue&type=script&lang=js"

import exportComponent from "D:\\SchoolManagement-Vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__